export default "__VITE_ASSET__C1yXnkWg__"